import React, { Component } from 'react'
import { Autocomplete, FormControl, TextField, Typography } from '@mui/material'

class SFStudentSearch extends Component {
    render() {

        let uniqueStudents = (this.props.students || []).filter(
            (student, index, self) =>
                index === self.findIndex((s) => s.userid === student.userid)
        );

        return (
            <div className='d-flex align-items-center student-search-container w-100'>
                <Typography fontWeight={600} color={'#000'} style={{ width: '100px' }}>Search by</Typography>
                <div className='w-100 d-flex'>
                    <FormControl sx={{ m: 1, minWidth: '250px', width: "100%", position: "relative" }}>
                        <Autocomplete
                            id="inst-students"
                            labelId="inst-students"
                            disablePortal
                            options={
                                [
                                    ...(this.props.hideSelectAll
                                        ? []
                                        : [
                                            {
                                                label: "Select All",
                                                value: "all",
                                                userName: "all",
                                                fullName: "all",
                                            },
                                        ]),
                                    ...uniqueStudents.map((student) => {
                                        let fullName = `${student.first_name} ${student.last_name}`;
                                        return {
                                            label: `${student.userid} - (${student.email_id})`,
                                            userName: student.userid,
                                            fullName: fullName,
                                            value: student.userid,
                                        };
                                    }),
                                ]

                            }
                            value={this.props.selectedStudentUserName}
                            onChange={(_, obj) => {
                                if (obj && obj.userName) {
                                    this.props.handleStudentSelect(obj.userName, obj.fullName)
                                } else {
                                    this.props.handleStudentSelect(null, null)
                                }
                            }}
                            // sx={{ minWidth: 200, maxWidth: 200 }}
                            renderInput={(params) => <TextField {...params} label="Search by student ID" />}
                        />
                    </FormControl>
                    <FormControl sx={{ m: 1, width: "100%", minWidth: '250px', }}>
                        <Autocomplete
                            id="inst-students"
                            labelId="inst-students"
                            disablePortal
                            options={uniqueStudents.map(student => {
                                let fullName = `${student.first_name} ${student.last_name}`;
                                return {
                                    label: `${fullName} - (${student.email_id})`,
                                    userName: student.userid,
                                    fullName: fullName,
                                    value: fullName,
                                }
                            })}
                            value={this.props.selectedStudentFullName}
                            onChange={(_, obj) => {
                                if (obj && obj.userName) {
                                    this.props.handleStudentSelect(obj.userName, obj.fullName)
                                } else {
                                    this.props.handleStudentSelect(null, null)
                                }
                            }}
                            // sx={{ width: 200 }}
                            renderInput={(params) => <TextField {...params} label="Search by First/Last Name" />}
                        />
                    </FormControl>
                </div>
            </div>
        )
    }
}

export default SFStudentSearch
